// Превключвателят между двата дневни отчета: „Персонални" и „Заведение".
//
// Сегментиран контрол, същата релса като в „Сторно" — на POS терминал се
// уцелва по-лесно от подчертани табове.
//
// Двата отчета са ОТДЕЛНИ URL-а (`/reports/personal` и `/reports/establishment`),
// затова превключването е навигация, а не локален state: така периодът се носи
// в `?date=`, sidebar-ът маркира верния елемент и правото се проверява от
// гейта на layout-а, а не тук.

export type DailyReportsTab = "personal" | "establishment";

type Props = {
  value: DailyReportsTab;
  onChange: (tab: DailyReportsTab) => void;
  labels: Record<DailyReportsTab, string>;
  /**
   * Кои табове изобщо да се рисуват. Отчетът на заведението е зад собствено
   * право — без него бутонът би водил до пренасочване към чужда справка.
   */
  tabs: readonly DailyReportsTab[];
};

export const DailyReportsTabs = ({
  value,
  onChange,
  labels,
  tabs,
}: Props) => {
  // Един-единствен разрешен таб не е избор — лентата само би заемала ред.
  if (tabs.length < 2) return null;

  return (
    <div
      role="tablist"
      className="flex shrink-0 items-center gap-1 self-start rounded-[10px] bg-fill-2 p-[3px]"
    >
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={value === tab}
          onClick={() => onChange(tab)}
          className={`h-[30px] whitespace-nowrap rounded-[7px] px-3.5 text-[12px] font-bold transition-colors ${
            value === tab
              ? "bg-brand-tint text-brand-deep-ink shadow-sm"
              : "text-soft hover:text-ink"
          }`}
        >
          {labels[tab]}
        </button>
      ))}
    </div>
  );
};
